import useSearchParams from '../hooks/use-search-params'

/**
 * Hook to parse the query string into a plain object (like the old )
 */
export function useQueryStringObject<T extends Record<string, string>>() {
    const [searchParams] = useSearchParams<T>()
    return searchParams
}
